<template lang="pug">
el-dialog(v-dialogDrag title="编辑模块" :visible.sync="dataDialog" width="400px" :before-close="handleClose")
  el-form(ref="form" :model="form" label-width="100px" size="small" label-position="top" :rules="rules")
    el-form-item(label="模块名称" prop="groupName")
      el-input(v-model="form.groupName" clearable maxlength="30" show-word-limit)
    el-form-item(label="表单页描述" prop="remark")
      el-input(v-model="form.remark" type="textarea" maxlength="50" show-word-limit)
  div(slot="footer")
      el-button(@click="handleClose" size="small") 取 消
      el-button(type="primary" @click="onSubmit" size="small") 确 定
</template>

<script>
import metadataService from "@/CommonDP/service/metadata-service.js";
export default {
  data () {
    return {
      dataDialog: false,
      form: {
        groupId: '',
        groupName: '',
        parentId: '',
        remark: ''
      },
      rules: {
        groupName: [{ required: true, message: '请填写模块名称', trigger: 'blur' }],
        groupId: [{ required: true, message: '请填写模块编号', trigger: 'blur' }]
      }
    };
  },
  methods: {
    // 编辑模块内容
    async openEditForm(data) {
      this.form = { ...data };
      this.dataDialog = true;
    },
    handleClose() {
      this.dataDialog = false;
    },
    /** @description: 新增参数描述
     * @param {groupId} 模块编号
     * @param {groupName} 模块名称
     * @param {parentId} 父ID
     * @param {remark} 描述
     */
    async onSubmit() {
      const { groupId, groupName, parentId, remark } = this.form;
      const params = {
        groupId, groupName, parentId, remark
      };
      try {
        await metadataService.updateGroup(params);
        this.$success("修改成功!");
        this.$emit('initTree', true);// 刷新同级节点
        this.form = {};
      } catch (error) {
        console.log(error);
      }
      this.dataDialog = false;
    }
  }
};
</script>

<style lang="scss" scoped></style>

